module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.model,
      "modelOrigin": _vm.modelOrigin,
      "label-width": "242px",
      "label-position": "left"
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.config.formFields), function(tab) {
    return _c('el-tab-pane', {
      key: tab.label,
      attrs: {
        "label": tab.label
      }
    }, [_vm._l((tab.body), function(item) {
      return _c(item.component, {
        key: item._uid,
        tag: "div",
        attrs: {
          "model": _vm.model,
          "modelOrigin": _vm.modelOrigin,
          "settings": _vm.settings,
          "root-config": _vm.rootConfig,
          "api": _vm.api,
          "options": item.options
        },
        on: {
          "updated": _vm.assignSettings
        }
      })
    }), _vm._v(" "), _vm._l((tab.fields), function(field) {
      return _c('el-form-item', {
        key: field.name,
        attrs: {
          "label": field.label
        }
      }, [(_vm.model[field.name.split('.')[0]]) ? _c(field.component, {
        tag: "div",
        attrs: {
          "placeholder": field.placeholder,
          "root-config": _vm.rootConfig,
          "options": field.options,
          "type": field.type,
          "root-model": _vm.model
        },
        model: {
          value: (
            _vm.model[field.name.split('.')[0]][
              field.name.split('.')[1]
            ]
          ),
          callback: function($$v) {
            _vm.$set(_vm.model[field.name.split('.')[0]],
              field.name.split('.')[1], $$v)
          },
          expression: "\n                            model[field.name.split('.')[0]][\n                                field.name.split('.')[1]\n                            ]\n                        "
        }
      }) : _vm._e()], 1)
    })], 2)
  }), 1), _vm._v(" "), (!_vm.hideSave) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Save")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7596a654"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 546
// module chunks = 1